/* Bored George - Bundle 2.0 builder. Tiers, prices and copy come from section settings. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.bgbReady === 'true') return;
    root.dataset.bgbReady = 'true';

    var config = JSON.parse(root.dataset.config || '{}');
    var tiers = (config.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
    var maxQty = tiers.length ? tiers[tiers.length - 1].qty : 3;
    var unitPrice = config.unitPrice || 0;

    var grid = root.querySelector('[data-bgb-grid]');
    var slotWrap = root.querySelector('[data-bgb-slots]');
    var statusLine = root.querySelector('[data-bgb-status-line]');
    var statusSub = root.querySelector('[data-bgb-status-sub]');
    var cta = root.querySelector('[data-bgb-cta]');
    var clearBtn = root.querySelector('[data-bgb-clear]');
    var errorBox = root.querySelector('[data-bgb-error]');
    var tierEls = root.querySelectorAll('[data-bgb-tier]');
    var expandBtn = root.querySelector('[data-bgb-expand]');

    var modal = root.querySelector('[data-bgb-modal]');
    var mImg = root.querySelector('[data-bgb-modal-img]');
    var mTitle = root.querySelector('[data-bgb-modal-title]');
    var mPrice = root.querySelector('[data-bgb-modal-price]');
    var mSizes = root.querySelector('[data-bgb-modal-sizes]');
    var mSizesRow = root.querySelector('[data-bgb-modal-sizes-row]');
    var mAdd = root.querySelector('[data-bgb-modal-add]');
    var mDesc = root.querySelector('[data-bgb-modal-desc]');
    var mLink = root.querySelector('[data-bgb-modal-link]');
    var mDots = root.querySelector('[data-bgb-dots]');
    var mTabs = root.querySelectorAll('[data-bgb-tab]');
    var mPanels = root.querySelectorAll('[data-bgb-panel]');
    var mRevCount = root.querySelector('[data-bgb-rev-count]');
    var mRevAvg = root.querySelector('[data-bgb-rev-avg]');
    var mRevStars = root.querySelector('[data-bgb-rev-stars]');
    var mHist = root.querySelector('[data-bgb-hist]');
    var mRevList = root.querySelector('[data-bgb-rev-list]');
    var mRevMore = root.querySelector('[data-bgb-rev-more]');
    var mTabRevLabel = root.querySelector('[data-bgb-tab-rev-label]');
    var mTabSizing = root.querySelector('[data-bgb-tab="sizing"]');
    var mSizingImg = root.querySelector('[data-bgb-sizing-img]');
    var mSizingText = root.querySelector('[data-bgb-sizing-text]');
    var mPrev = root.querySelector('[data-bgb-prev]');
    var mNext = root.querySelector('[data-bgb-next]');

    /* Star rating under the price in the quick view. Built here rather than in
       the section so the modal markup does not have to be edited. */
    var mRating = null;
    if (mPrice) {
      mRating = document.createElement('div');
      mRating.className = 'bgb__modal-rating';
      mRating.hidden = true;
      mPrice.insertAdjacentElement('afterend', mRating);
    }

    /* Personalise step */
    var pers = config.personalise || {};
    var persOn = !!(pers.enabled && pers.firstId);
    var pWrap = root.querySelector('[data-bgp]');
    var pRows = root.querySelector('[data-bgp-rows]');
    var pTitle = root.querySelector('[data-bgp-title]');
    var pIntro = root.querySelector('[data-bgp-intro]');
    var pAdd = root.querySelector('[data-bgp-add]');
    var pSkip = root.querySelector('[data-bgp-skip]');
    var pError = root.querySelector('[data-bgp-error]');

    var mCard = null;
    var mMedia = [];
    var mIndex = 0;
    var mVariantId = null;

    /* Bumped on every image request. A load that finishes after a newer one
       has been asked for is dropped, so a slow photo from the tile you looked
       at ten seconds ago can never land on the product you are looking at now. */
    var mToken = 0;

    var selection = [];
    var busy = false;

    /* Standard bundle is the first tier. Higher tiers are opt-in via the + control,
       so an empty bar shows two slots, not three. */
    var baseQty = tiers.length ? tiers[0].qty : 1;
    var expanded = false;

    function visibleMax() { return expanded ? maxQty : baseQty; }

    function ordinal(n) {
      var s10 = n % 100;
      if (s10 >= 11 && s10 <= 13) return n + 'th';
      var s1 = n % 10;
      if (s1 === 1) return n + 'st';
      if (s1 === 2) return n + 'nd';
      if (s1 === 3) return n + 'rd';
      return n + 'th';
    }

    function money(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      var whole = parts[0];
      var grouped = '';
      while (whole.length > 3) {
        grouped = ',' + whole.slice(-3) + grouped;
        whole = whole.slice(0, -3);
      }
      return '$' + whole + grouped + '.' + parts[1];
    }

    function tierFor(count) {
      var best = null;
      for (var i = 0; i < tiers.length; i++) {
        if (count >= tiers[i].qty) best = tiers[i];
      }
      return best;
    }

    function nextTier(count) {
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].qty > count) return tiers[i];
      }
      return null;
    }

    function fullPrice() {
      return selection.reduce(function (sum, item) { return sum + item.price; }, 0);
    }

    function bundlePrice() {
      var t = tierFor(selection.length);
      if (!t) return fullPrice();
      return t.price + ((selection.length - t.qty) * unitPrice);
    }

    function currentVariantId(card) {
      var sel = card.querySelector('[data-bgb-variant]');
      return sel ? sel.value : card.dataset.variantId;
    }

    function currentVariantData(card) {
      var sel = card.querySelector('[data-bgb-variant]');
      if (sel) {
        var opt = sel.options[sel.selectedIndex];
        return {
          variantId: sel.value,
          price: parseInt(opt.dataset.price, 10),
          title: card.dataset.title + ' - ' + opt.textContent.trim(),
          available: opt.dataset.available === 'true'
        };
      }
      return {
        variantId: card.dataset.variantId,
        price: parseInt(card.dataset.price, 10),
        title: card.dataset.title,
        available: card.dataset.available === 'true'
      };
    }

    function showError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg;
      errorBox.dataset.shown = 'true';
      setTimeout(function () { errorBox.dataset.shown = 'false'; }, 5000);
    }

    function render() {
      var count = selection.length;
      var vmax = visibleMax();

      var cards = grid ? grid.querySelectorAll('[data-bgb-card]') : [];
      Array.prototype.forEach.call(cards, function (card) {
        var vid = currentVariantId(card);
        var n = selection.filter(function (s) { return String(s.variantId) === String(vid); }).length;
        card.dataset.selected = n > 0 ? 'true' : 'false';
        var badge = card.querySelector('[data-bgb-count]');
        if (badge) badge.textContent = n;
        var btn = card.querySelector('[data-bgb-add]');
        if (btn) {
          btn.textContent = n > 0 ? (config.addedText || 'Added') : (config.addText || 'Add to bundle');
          btn.disabled = count >= vmax && n === 0;
        }
      });

      Array.prototype.forEach.call(tierEls, function (el) {
        el.dataset.reached = count >= parseInt(el.dataset.bgbTier, 10) ? 'true' : 'false';
      });

      if (slotWrap) {
        slotWrap.innerHTML = '';
        for (var i = 0; i < vmax; i++) {
          var slot = document.createElement('div');
          slot.className = 'bgb__slot';
          var item = selection[i];
          if (item) {
            slot.dataset.filled = 'true';
            if (item.image) slot.style.backgroundImage = 'url(' + item.image + ')';
            slot.title = item.title;
            var x = document.createElement('button');
            x.className = 'bgb__slot-x';
            x.type = 'button';
            x.setAttribute('aria-label', 'Remove ' + item.title);
            x.innerHTML = '&times;';
            x.dataset.index = String(i);
            x.addEventListener('click', function (e) {
              selection.splice(parseInt(e.currentTarget.dataset.index, 10), 1);
              render();
            });
            slot.appendChild(x);
          } else {
            slot.dataset.filled = 'false';
            var num = document.createElement('span');
            num.className = 'bgb__slot-num';
            num.textContent = String(i + 1);
            slot.appendChild(num);
          }
          slotWrap.appendChild(slot);
        }
      }

      if (expandBtn) {
        var canExpand = !expanded && tiers.length > 1 && maxQty > baseQty;
        expandBtn.hidden = !canExpand;
        if (canExpand) {
          var step = tiers[1].price - tiers[0].price;
          expandBtn.textContent = '+ '
            + (config.expandText || 'Add a ' + ordinal(tiers[1].qty) + ' pair')
            + ' for ' + money(step);
        }
      }

      var nxt = expanded ? nextTier(count) : null;
      if (statusLine) {
        statusLine.textContent = (config.bundleLabel || 'Your bundle') + ' (' + count + '/' + vmax + ')';
      }
      if (statusSub) {
        if (count === 0) {
          statusSub.textContent = config.emptyHint || 'Pick your first pair to get started';
        } else if (count < baseQty) {
          var need = baseQty - count;
          var save0 = (unitPrice * baseQty) - tiers[0].price;
          statusSub.innerHTML = 'Add ' + need + ' more ' + (need === 1 ? 'pair' : 'pairs')
            + ' to pay <strong>' + money(tiers[0].price) + '</strong> '
            + '<span class="bgb__save">(save ' + money(save0) + ')</span>';
        } else if (nxt) {
          var needed = nxt.qty - count;
          var saving = (unitPrice * nxt.qty) - nxt.price;
          statusSub.innerHTML = 'Add ' + needed + ' more ' + (needed === 1 ? 'pair' : 'pairs')
            + ' to pay <strong>' + money(nxt.price) + '</strong> '
            + '<span class="bgb__save">(save ' + money(saving) + ')</span>';
        } else {
          var full = fullPrice();
          var now = bundlePrice();
          statusSub.innerHTML = '<span class="bgb__was">' + money(full) + '</span>'
            + '<strong>' + money(now) + '</strong> '
            + '<span class="bgb__save">save ' + money(full - now) + '</span>';
        }
      }

      if (cta) {
        cta.disabled = count < baseQty;
        cta.textContent = count < baseQty
          ? (config.ctaIncomplete || 'Add to cart')
          : (config.ctaText || 'Add to cart') + ' · ' + money(bundlePrice());
      }

      if (clearBtn) clearBtn.hidden = count === 0;
    }

    /* ---------- quick view ---------- */

    /* Warm the browser cache without touching the DOM. */
    function preload(url) {
      if (!url) return;
      var p = new Image();
      p.decoding = 'async';
      p.src = url;
    }

    function showImage(i) {
      if (!mMedia.length) return;
      mIndex = (i + mMedia.length) % mMedia.length;

      var token = ++mToken;
      var url = mMedia[mIndex];

      if (mImg) {
        var loader = new Image();
        loader.decoding = 'async';
        loader.onload = function () {
          if (token !== mToken) return;
          mImg.src = url;
          /* Next and previous, so tapping an arrow is instant. */
          preload(mMedia[(mIndex + 1) % mMedia.length]);
          preload(mMedia[(mIndex - 1 + mMedia.length) % mMedia.length]);
        };
        loader.src = url;
        /* Already in cache: swap now rather than waiting a frame for onload. */
        if (loader.complete) mImg.src = url;
      }

      if (mDots) {
        Array.prototype.forEach.call(mDots.children, function (d, n) {
          d.dataset.on = n === mIndex ? 'true' : 'false';
        });
      }
      var many = mMedia.length > 1;
      if (mPrev) mPrev.hidden = !many;
      if (mNext) mNext.hidden = !many;
    }

    function buildDots() {
      if (!mDots) return;
      mDots.innerHTML = '';
      if (mMedia.length < 2) return;
      mMedia.forEach(function (_, n) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'bgb__gal-dot';
        d.dataset.on = n === 0 ? 'true' : 'false';
        d.setAttribute('aria-label', 'Image ' + (n + 1));
        d.addEventListener('click', function () { showImage(n); });
        mDots.appendChild(d);
      });
    }

    function buildSizes(card) {
      if (!mSizes || !mSizesRow) return;
      var sel = card.querySelector('[data-bgb-variant]');
      mSizesRow.innerHTML = '';
      if (!sel) {
        mSizes.hidden = true;
        mVariantId = card.dataset.variantId;
        return;
      }
      mSizes.hidden = false;
      mVariantId = sel.value;
      Array.prototype.forEach.call(sel.options, function (opt) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bgb__size';
        b.textContent = opt.textContent.trim().replace(' - sold out', '');
        b.disabled = opt.dataset.available !== 'true';
        b.dataset.on = opt.value === mVariantId ? 'true' : 'false';
        b.dataset.variantId = opt.value;
        b.addEventListener('click', function () {
          mVariantId = opt.value;
          sel.value = opt.value;
          Array.prototype.forEach.call(mSizesRow.children, function (c) {
            c.dataset.on = c.dataset.variantId === mVariantId ? 'true' : 'false';
          });
          render();
        });
        mSizesRow.appendChild(b);
      });
    }

    function setTab(name) {
      Array.prototype.forEach.call(mTabs, function (t) {
        t.dataset.on = t.dataset.bgbTab === name ? 'true' : 'false';
      });
      Array.prototype.forEach.call(mPanels, function (p) {
        p.hidden = p.dataset.bgbPanel !== name;
      });
    }

    function starMarkup(pct) {
      return '<span class="bgb__stars">★★★★★'
        + '<span class="bgb__stars-on" style="--pct:' + pct + '%">★★★★★</span></span>';
    }

    function renderReviews(card) {
      var data = {};
      try { data = JSON.parse(card.dataset.reviews || '{}'); } catch (e) { data = {}; }
      var count = data.count || 0;
      var avg = parseFloat(data.avg || 0);

      if (mTabRevLabel) mTabRevLabel.textContent = count ? 'Reviews (' + count + ')' : 'Reviews';
      if (mRevAvg) mRevAvg.textContent = count ? avg.toFixed(2) : '-';
      if (mRevStars) mRevStars.innerHTML = starMarkup(count ? (avg / 5) * 100 : 0);
      if (mRevCount) mRevCount.textContent = count ? 'Based on ' + count + ' review' + (count === 1 ? '' : 's') : 'No reviews yet';

      /* The row under the price. Hidden entirely when a style has no reviews -
         an empty set of grey stars reads worse than nothing. */
      if (mRating) {
        if (count > 0) {
          mRating.innerHTML = starMarkup((avg / 5) * 100)
            + '<span class="bgb__modal-rating-count">' + count + ' review' + (count === 1 ? '' : 's') + '</span>';
          mRating.hidden = false;
        } else {
          mRating.innerHTML = '';
          mRating.hidden = true;
        }
      }

      if (mHist) {
        mHist.innerHTML = '';
        (data.hist || []).forEach(function (h) {
          var row = document.createElement('div');
          row.className = 'bgb__hist-row';
          row.innerHTML = '<span class="bgb__hist-star">' + h.r + '★</span>'
            + '<span class="bgb__hist-track"><span class="bgb__hist-fill" style="width:' + (h.p || 0) + '%"></span></span>'
            + '<span class="bgb__hist-n">' + (h.f || 0) + '</span>';
          mHist.appendChild(row);
        });
      }

      if (mRevList) {
        mRevList.innerHTML = '';
        var list = data.items || [];
        if (!list.length) {
          var e = document.createElement('p');
          e.className = 'bgb__rev-empty';
          e.textContent = 'No reviews for this style yet.';
          mRevList.appendChild(e);
        }
        list.forEach(function (rv) {
          var el = document.createElement('div');
          el.className = 'bgb__rev';
          el.innerHTML = '<div class="bgb__rev-top">'
            + '<span class="bgb__rev-name">' + (rv.n || 'Anonymous') + '</span>'
            + (rv.v ? '<span class="bgb__rev-verified">Verified</span>' : '')
            + '<span class="bgb__rev-date">' + (rv.d || '') + '</span></div>'
            + starMarkup((parseFloat(rv.r || 0) / 5) * 100)
            + (rv.t ? '<p class="bgb__rev-title">' + rv.t + '</p>' : '')
            + '<p class="bgb__rev-body">' + (rv.b || '') + '</p>';
          mRevList.appendChild(el);
        });
      }

      if (mRevMore) {
        mRevMore.innerHTML = '';
        if (count > (data.items || []).length && card.dataset.url) {
          var a = document.createElement('a');
          a.href = card.dataset.url + '#judgeme_product_reviews';
          a.textContent = 'Read all ' + count + ' reviews';
          mRevMore.appendChild(a);
        }
      }
    }

    function renderSizing(card) {
      var hasImg = !!card.dataset.sizingImg;
      var hasText = !!card.dataset.sizingText;
      var has = hasImg || hasText;

      if (mTabSizing) mTabSizing.hidden = !has;

      if (mSizingImg) {
        if (hasImg) {
          mSizingImg.src = card.dataset.sizingImg;
          mSizingImg.alt = (card.dataset.title || '') + ' measurements';
          mSizingImg.hidden = false;
        } else {
          mSizingImg.hidden = true;
          mSizingImg.removeAttribute('src');
        }
      }
      if (mSizingText) mSizingText.innerHTML = card.dataset.sizingText || '';
      return has;
    }

    function openModal(card) {
      if (!modal) return;
      mCard = card;
      try { mMedia = JSON.parse(card.dataset.media || '[]'); } catch (e) { mMedia = []; }
      if (!mMedia.length && card.dataset.image) mMedia = [card.dataset.image];

      /* Paint the tile's own photo first. That file is already decoded in the
         browser, so the modal opens on the RIGHT product instantly instead of
         holding the previous product's picture while the large one downloads.
         The full-size version swaps in behind it a moment later. */
      if (mImg) {
        var thumb = card.querySelector('img');
        var instant = (thumb && (thumb.currentSrc || thumb.src)) || card.dataset.image || '';
        if (instant) mImg.src = instant;
        else mImg.removeAttribute('src');
      }

      if (mTitle) mTitle.textContent = card.dataset.title || '';
      if (mPrice) mPrice.textContent = money(parseInt(card.dataset.price, 10) || 0);
      if (mDesc) mDesc.textContent = card.dataset.description || '';
      if (mLink) {
        mLink.innerHTML = '';
        if (card.dataset.url) {
          var a = document.createElement('a');
          a.href = card.dataset.url;
          a.textContent = 'View full product details';
          mLink.appendChild(a);
        }
      }
      buildSizes(card);
      buildDots();
      showImage(0);
      renderReviews(card);
      renderSizing(card);
      setTab('details');

      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (mAdd) mAdd.focus();
    }

    function closeModal() {
      if (!modal) return;
      /* Invalidate anything still downloading for this product. */
      mToken++;
      modal.hidden = true;
      document.body.style.overflow = '';
      mCard = null;
    }

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-bgb-modal-close]')) closeModal();
      });
      document.addEventListener('keydown', function (e) {
        if (modal.hidden) return;
        if (e.key === 'Escape') closeModal();
        if (e.key === 'ArrowLeft') showImage(mIndex - 1);
        if (e.key === 'ArrowRight') showImage(mIndex + 1);
      });
    }
    Array.prototype.forEach.call(mTabs, function (t) {
      t.addEventListener('click', function () { setTab(t.dataset.bgbTab); });
    });
    if (mPrev) mPrev.addEventListener('click', function () { showImage(mIndex - 1); });
    if (mNext) mNext.addEventListener('click', function () { showImage(mIndex + 1); });

    if (mAdd) {
      mAdd.addEventListener('click', function () {
        if (!mCard) return;
        if (addCard(mCard)) closeModal();
      });
    }

    /* ---------- personalise step ----------
       One row per pair. A pair is only charged if initials are typed, and the
       first charged case uses the full-price product while the rest use the
       cheaper one. Everything - pairs and cases - goes to the cart in a single
       request, so there is no ordering race and no half-added cart. */

    function persInputs() {
      if (!pRows) return [];
      return Array.prototype.slice.call(pRows.querySelectorAll('[data-bgp-input]'));
    }

    function persUnit(nth) {
      if (nth === 1 || !pers.extraId) return pers.firstPrice || 0;
      return pers.extraPrice || 0;
    }

    function persRender() {
      var charged = 0;
      var total = 0;
      persInputs().forEach(function (input) {
        var row = input.closest('.bgp__row');
        var on = input.value.length > 0;
        var priceEl = row ? row.querySelector('[data-bgp-row-price]') : null;
        if (row) row.dataset.on = on ? 'true' : 'false';
        if (!on) {
          if (priceEl) priceEl.textContent = '';
          return;
        }
        charged++;
        var unit = persUnit(charged);
        total += unit;
        if (priceEl) priceEl.textContent = money(unit);
      });
      if (pAdd) {
        pAdd.textContent = (pers.addLabel || 'Add to cart') + ' · ' + money(bundlePrice() + total);
      }
    }

    function persItems() {
      var charged = 0;
      var out = [];
      persInputs().forEach(function (input) {
        var value = input.value;
        if (!value) return;
        charged++;
        var useFirst = charged === 1 || !pers.extraId;
        var idx = parseInt(input.dataset.bgpInput, 10);
        var pair = selection[idx];
        out.push({
          id: parseInt(useFirst ? pers.firstId : pers.extraId, 10),
          quantity: 1,
          properties: {
            'Initials': value,
            'For': pair ? pair.title : 'Sunglasses',
            '_bundle': config.bundleKey || 'bundle'
          }
        });
      });
      return out;
    }

    function cleanInitials(raw) {
      var upper = (raw || '').toUpperCase();
      var out = '';
      for (var i = 0; i < upper.length; i++) {
        var ch = upper.charAt(i);
        if (ch >= 'A' && ch <= 'Z') out += ch;
      }
      return out;
    }

    function openPersonalise() {
      if (!pWrap || !pRows) return;
      pRows.innerHTML = '';

      selection.forEach(function (item, i) {
        var row = document.createElement('div');
        row.className = 'bgp__row';
        row.dataset.on = 'false';

        var thumb = document.createElement('span');
        thumb.className = 'bgp__thumb';
        if (item.image) thumb.style.backgroundImage = 'url(' + item.image + ')';

        var main = document.createElement('span');
        main.className = 'bgp__row-main';

        var name = document.createElement('span');
        name.className = 'bgp__row-name';
        name.textContent = item.title;

        var input = document.createElement('input');
        input.type = 'text';
        input.className = 'bgp__input';
        input.maxLength = pers.maxLen || 3;
        input.placeholder = pers.placeholder || 'ABC';
        input.autocomplete = 'off';
        input.spellcheck = false;
        input.setAttribute('autocorrect', 'off');
        input.setAttribute('data-bgp-input', String(i));
        input.setAttribute('aria-label', 'Initials for ' + item.title);
        input.addEventListener('input', function () {
          this.value = cleanInitials(this.value);
          persRender();
        });

        var price = document.createElement('span');
        price.className = 'bgp__row-price';
        price.setAttribute('data-bgp-row-price', '');

        main.appendChild(name);
        main.appendChild(input);
        row.appendChild(thumb);
        row.appendChild(main);
        row.appendChild(price);
        pRows.appendChild(row);
      });

      if (pTitle) pTitle.textContent = pers.heading || 'Make it yours';
      if (pIntro) pIntro.textContent = pers.intro || '';
      if (pSkip) pSkip.textContent = pers.skip || 'No thanks, just the sunglasses';
      if (pError) pError.hidden = true;
      if (pAdd) pAdd.dataset.busy = 'false';

      persRender();
      pWrap.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closePersonalise() {
      if (!pWrap) return;
      pWrap.hidden = true;
      document.body.style.overflow = '';
    }

    if (pWrap) {
      pWrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-bgp-close]')) closePersonalise();
      });
      document.addEventListener('keydown', function (e) {
        if (!pWrap.hidden && e.key === 'Escape') closePersonalise();
      });
    }
    if (pAdd) pAdd.addEventListener('click', function () { submitCart(persItems()); });
    if (pSkip) pSkip.addEventListener('click', function () { submitCart([]); });

    /* ---------- cart ---------- */
    function submitCart(extras) {
      if (busy || !selection.length) return;
      busy = true;
      if (cta) cta.dataset.busy = 'true';
      if (pAdd) pAdd.dataset.busy = 'true';
      if (pError) pError.hidden = true;

      var items = selection.map(function (s) {
        return {
          id: parseInt(s.variantId, 10),
          quantity: 1,
          properties: { '_bundle': config.bundleKey || 'bundle', '_bundle_size': String(selection.length) }
        };
      });
      (extras || []).forEach(function (x) { items.push(x); });

      var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart');
          return r.json();
        })
        .then(function () {
          closePersonalise();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (typeof window.unicornOpenCart === 'function') {
            window.unicornOpenCart();
            selection = [];
            expanded = false;
            render();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          var msg = config.errorText || 'Something went wrong adding to cart. Please try again.';
          if (pWrap && !pWrap.hidden && pError) {
            pError.textContent = msg;
            pError.hidden = false;
          } else {
            showError(msg);
          }
        })
        .finally(function () {
          busy = false;
          if (cta) cta.dataset.busy = 'false';
          if (pAdd) pAdd.dataset.busy = 'false';
        });
    }

    /* ---------- events ---------- */
    function addCard(card) {
      var v = currentVariantData(card);
      if (!v.available) { showError(config.soldOutText || 'That one is sold out'); return false; }
      if (selection.length >= visibleMax()) {
        if (!expanded && maxQty > baseQty) {
          showError(config.expandHint || 'Tap + in the bundle bar to add another pair');
        } else {
          showError((config.fullText || 'Your bundle is full') + ' (' + maxQty + ')');
        }
        return false;
      }
      selection.push({
        variantId: v.variantId,
        productId: card.dataset.productId,
        title: v.title,
        image: card.dataset.image,
        price: v.price
      });
      render();
      return true;
    }

    if (grid) {
      /* Start fetching a tile's first full-size photo as soon as the shopper
         hovers or touches it, so the modal usually opens on a cached image. */
      var prefetched = {};
      function prefetchCard(card) {
        if (!card) return;
        var key = card.dataset.productId;
        if (!key || prefetched[key]) return;
        prefetched[key] = true;
        var list = [];
        try { list = JSON.parse(card.dataset.media || '[]'); } catch (e) { list = []; }
        preload(list[0]);
      }

      grid.addEventListener('pointerover', function (e) {
        prefetchCard(e.target.closest('[data-bgb-card]'));
      });
      grid.addEventListener('touchstart', function (e) {
        prefetchCard(e.target.closest('[data-bgb-card]'));
      }, { passive: true });

      grid.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bgb-add]');
        if (btn) {
          var card = btn.closest('[data-bgb-card]');
          if (card) addCard(card);
          return;
        }
        var opener = e.target.closest('[data-bgb-open]');
        if (opener) {
          var oCard = opener.closest('[data-bgb-card]');
          if (oCard && oCard.dataset.soldout !== 'true') openModal(oCard);
        }
      });

      grid.addEventListener('change', function (e) {
        if (e.target.matches('[data-bgb-variant]')) render();
      });
    }

    if (expandBtn) {
      expandBtn.addEventListener('click', function () {
        expanded = true;
        render();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        selection = [];
        expanded = false;
        render();
      });
    }

    if (cta) {
      cta.addEventListener('click', function () {
        if (busy || !selection.length) return;
        if (persOn) { openPersonalise(); return; }
        submitCart([]);
      });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-bgb-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
